var map = {
	"./ALGERIAN PORT COMMUNITY SYSTEM/64b26ce72f6e10fe25acd3b0_0.png": 1719,
	"./Abnormal Behavior Detection System/64a0bcc4121d64216651587b_0.png": 1578,
	"./E-Commerce Platform/64a0bc87121d642166515879_0.png": 495,
	"./Kabylo's Pizza By The Slice Website With Worpress/64c4183098bff9b025239ab6_0.png": 9300,
	"./Sonatach Pipeline Transport System/64b27cef2f6e10fe25acd3b3_0.png": 2959
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2505;